import { translations } from '../translations.js.erb'

const modalContent = `
  <p>${translations.map.radius_search.body}</p>
  <div class="form-group">
    <label id="radiusSearch_address_label" for="radiusSearch_address_input">${translations.map.radius_search.address_input_header}</label>
    <div class="c-search-input">
      <span class="flexicon flexicon-search"></span>
      <div id="radiusSearch_address" data-map--radius-search-target="addressInput" class="form-control radius-search-address-autocomplete" data-placeholder="${translations.map.radius_search.address_placeholder}"></div>
      <button class="flexicon flexicon-close" style="display: none;">
      </button>
    </div>
  </div>
  <div class="form-group">
    <label for="radiusSearch_distance">${translations.map.radius_search.radius_input_header} (${translations.map.radius_search.distance_unit})</label>
    <div class="c-search-input">
    <button id="radiusSearch_radius_decrease" data-action="click->map--radius-search#radiusDecrease"><span class="flexicon flexicon-180 flexicon-chevron"></span></button>
    <input type="number" id="radiusSearch_distance" data-map--radius-search-target="radiusInput" data-action="blur->map--radius-search#setRadiusInputValue" class="form-control" min="0" max="${getMaxSearchRadius()}" value="1">
    <button id="radiusSearch_radius_increase" data-action="click->map--radius-search#radiusIncrease"><span class="flexicon flexicon-chevron"></span></button>
  </div>
  <p class="help-block">${translations.map.radius_search.radius_input_help_text}</p>
`;

const modalFooter = `
  <button type="button" id="cancelRadiusSearchBtn" class="btn btn-tertiary" data-dismiss="modal">
    ${translations.map.radius_search.cancel}
  </button>
  <button type="button" id="confirmRadiusSearchBtn" class="btn btn-primary disabled" data-map--radius-search-target="confirmButton" data-action="click->map--radius-search#confirmRadiusSearch">
    ${translations.map.radius_search.confirm}
  </button>
`;

const modalHeader = `<div class="t-title--large">${translations.map.radius_search.title}</div>`;

export function showRadiusSearchModal(evt) {
  window.dispatchEvent(new CustomEvent("display-local-modal", {
    detail: {
      modalCssClasses: "modal-dialog modal-sm c-modal radius-search-modal",
      modalHeader: modalHeader,
      modalContent: modalContent,
      modalFooterContent: modalFooter,
      modalDataController: "map--radius-search"
    }
  }));
}

// Currently these functions only work in miles, but can be extended to other units in the future
export function getMaxSearchRadius() {
  // API limit reference:
  // https://github.fbsdata.com/programming/api/blob/8bcf051e6295f30b129e5efaaea735629ba3f326/lib/geo.rb#L2-L4

  // Hard coded max search radius for now, might be lower in the future.
  // The API limit is far too high for the clusters service to handle.
  // No one should need a radius of 12,000+ miles.
  return 500;
}

export function getDistanceUnit() {
  return translations.map.radius_search.distance_unit;
}

